export default __webpack_public_path__ + "static/media/05.057dee25.jpg";